module.exports = __webpack_public_path__ + "1.4.15-unryo/img/microsoft-sql-server.35528815.svg";